function appDisplay() {
  'ngInject';
  return {
    restrict: 'E',
    template: require('./app-display.html'),
    scope: {},
    controller: 'AppDisplayController',
    controllerAs: 'vm',
    bindToController: {
      app: '=',
      screen: '='
    }
  };
}

function AppDisplayController($state) {
  'ngInject';
  const vm = this;

  vm.$onInit = () => {
    vm.fields = _prepareData(vm.app, vm.screen);
  };

  function _prepareData(app, screen) {
    const base = {
      label: app.name,
      appId: app.default_store_app_id || app.id
    };

    if (screen === 'secret-statistics') {
      return {
        ...base,
        href: $state.href('apps.setup.secrets', { appToken: app.token }),
        title: t('label.return-to-sdk-signature')
      };
    }

    return base;
  }
}

export { AppDisplayController, appDisplay };
